import { PrefetchLink } from "@/components/routing/PrefetchLink";
import { Box, Group, Image, Text } from "@mantine/core";
import styles from "../category/styles/CategoryTile.module.css";
import curated from "../curated/styles/Curated.module.css";
import { filterText, getPodcastImage, ImageSizes, truncate } from "@/core/helpers";
import { Urls } from "@/core/urls";
import { CoverImage } from "@/components/podcast/CoverImage";
import { CoverCredit, CoverOverlay, CoverPicture, useCreditRoom } from "@/components/curated/CuratedCover";
import { coverOf } from "@/core/cover";

const SLOTS = [0, 1, 2, 3];

const TILE_SIZES = "(width <= 48em) 100vw, 360px";

/** The podcasts shown as small covers on top of the photo, as in the mosaic a collection without a photo gets */
const PHOTO_THUMBS = 4;
const THUMB = 52;
/** A soft dark glow, so the covers stand out from the photo whatever its colours */
const THUMB_SHADOW = "0 2px 10px rgb(0 0 0 / 65%)";

export const CollectionTile = ({ collection }: { collection: Collection }) => {
    const cover = coverOf(collection);
    const [creditRoom, creditRef] = useCreditRoom();
    const tile = (
        <PrefetchLink className={styles.tile} to={Urls.collection(collection.slug)}>
            {cover ? (
                <Box pos="relative">
                    <CoverPicture className={curated.tileImage} cover={cover} sizes={TILE_SIZES} widths={[360, 720]} />
                    <CoverOverlay
                        creditRoom={creditRoom}
                        aside={
                            <Group aria-hidden="true" gap={6} wrap="nowrap">
                                {collection.podcasts.slice(0, PHOTO_THUMBS).map((podcast) => (
                                    <Image
                                        alt=""
                                        h={THUMB}
                                        key={podcast.id}
                                        loading="lazy"
                                        radius="sm"
                                        src={getPodcastImage(podcast, ImageSizes.Small)}
                                        style={{ boxShadow: THUMB_SHADOW }}
                                        w={THUMB}
                                    />
                                ))}
                            </Group>
                        }
                        count={
                            <Text c="gray.3" size="sm">
                                {collection.podcasts.length} poddar
                            </Text>
                        }
                        title={
                            <Text c="white" fw={700} lh={1.25} lineClamp={2} size="lg">
                                {collection.name}
                            </Text>
                        }
                    />
                </Box>
            ) : (
                <div aria-hidden="true" className={styles.thumbs}>
                    {SLOTS.map((i) => {
                        const podcast = collection.podcasts[i];
                        return podcast ? (
                            <CoverImage className={styles.thumb} key={podcast.id} podcast={podcast} />
                        ) : (
                            <span className={styles.thumbEmpty} key={i} />
                        );
                    })}
                </div>
            )}
            <div className={styles.body}>
                {!cover && (
                    <>
                        <Text className={styles.name} fw={700}>
                            {collection.name}
                        </Text>
                        <Text c="dimmed" size="sm">
                            {collection.podcasts.length} poddar
                        </Text>
                    </>
                )}
                {collection.content && (
                    <Text c="dimmed" className={curated.excerpt} lineClamp={3} size="sm">
                        {truncate(filterText(collection.content), 160)}
                    </Text>
                )}
                <span className={styles.cta}>Utforska →</span>
            </div>
        </PrefetchLink>
    );

    if (!cover) return tile;
    return (
        <div className={curated.tileWrap}>
            {tile}
            <CoverCredit className={curated.tileCredit} cover={cover} ref={creditRef} />
        </div>
    );
};
